import Add from './add'
import ArrowDown from './arrow_down'
import AlignLeft from './align_left'
import AlignRight from './align_right'
import AlignJustify from './align_justify'
import AlignCenter from './align_center'
import FontSize from './font_size'
import ArrowUp from './arrow_up'
import Back from './back'
import BackWhite from './back_white'
import Bold from './bold'
import Bug from './bug'
import Chrome from './chrome'
import Close from './close'
import CloudOff from './cloud_off'
import Code from './code'
import Delete from './delete'
import Desktop from './desktop'
import Dns from './dns'
import Download from './download'
import Edit from './edit'
import EDM from './edm'
import ErrorOutline from './error_outline'
import Filter from './filter'
import FormatClear from './format_clear'
import Fullscreen from './fullscreen'
import FullscreenExit from './fullscreen_exit'
import History from './history'
import Image from './image'
import Images from './images'
import Indent from './indent'
import Info from './info'
import Italic from './italic'
import Layers from './layers'
import Link from './link'
import Logo from './logo'
import Mobile from './mobile'
import NewWindow from './new_window'
import OList from './olist'
import Outdent from './outdent'
import Palette from './palette'
import Preview from './preview'
import Publish from './publish'
import Remove from './remove'
import Redo from './redo'
import Undo from './undo'
import Save from './save'
import Search from './search'
import Setting from './setting'
import Sort from './sort'
import Stop from './stop'
import Sync from './sync'
import Text from './text'
import ToggleSidebarLeft from './toggle_sidebar_left'
import ToggleSidebarRight from './toggle_sidebar_right'
import UList from './ulist'
import Underline from './underline'
import Video from './video'
import Zoomin from './zoomin'
import Zoomout from './zoomout'

export default {
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  'align-justify': AlignJustify,
  'align-center': AlignCenter,
  'font-size': FontSize,
  'back': Back,
  'back-white': BackWhite,
  'cloud-off': CloudOff,
  'error-outline': ErrorOutline,
  'format-clear': FormatClear,
  'fullscreen-exit': FullscreenExit,
  'new-window': NewWindow,
  'toggle-sidebar-left': ToggleSidebarLeft,
  'toggle-sidebar-right': ToggleSidebarRight,
  add: Add,
  redo: Redo,
  undo: Undo,
  bold: Bold,
  bug: Bug,
  chrome: Chrome,
  close: Close,
  code: Code,
  delete: Delete,
  desktop: Desktop,
  dns: Dns,
  download: Download,
  edit: Edit,
  edm: EDM,
  filter: Filter,
  fullscreen: Fullscreen,
  history: History,
  image: Image,
  images: Images,
  indent: Indent,
  info: Info,
  italic: Italic,
  layers: Layers,
  link: Link,
  logo: Logo,
  mobile: Mobile,
  olist: OList,
  outdent: Outdent,
  palette: Palette,
  preview: Preview,
  publish: Publish,
  remove: Remove,
  save: Save,
  search: Search,
  setting: Setting,
  sort: Sort,
  stop: Stop,
  sync: Sync,
  text: Text,
  ulist: UList,
  underline: Underline,
  video: Video,
  zoomin: Zoomin,
  zoomout: Zoomout
}



// WEBPACK FOOTER //
// ./src/components/icons/index.js